module.exports = __webpack_public_path__ + "static/media/FrutigerNeueLTW04-Black.33114fcc.woff";